export default __webpack_public_path__ + "static/media/cain4.cdb3f6d5.jpg";